<dff-side [observable]="kvittering$">
  @if (kvittering$ | async; as kvittering) {
    <dff-kvittering [kvittering]="kvittering"></dff-kvittering>
  }
</dff-side>
